import * as hpServicesApi from "../../api/healthPlanServicesApi";
import * as types from "../../constants/actionTypes";
import { call, put, select } from "redux-saga/effects";
import { logAPI } from "../../api/andyliticsApi";

export function* getMembers() {
    const start = new Date();
    const domainData = yield select((state) => state.domain);
    const stateData = yield select((state) => state.common);
    const sessionData = yield select((state) => state.session);
    const memid = domainData.aai || domainData.hi || (sessionData.healthPlanUserProfile ? sessionData.healthPlanUserProfile.memberUserClaims.memberHccId : null);
    if (stateData && stateData.aalDown === false) {
        try {
            if (domainData && domainData.t) {
                const response = yield call(hpServicesApi.MemberApi.getListOfMembers, domainData.t, memid); //t = access token, aai = American Airlines id
                //response.map((member) => {
                //    //if (member.TermDate) {
                //    //    //If current time is between Effective and Term then active, else if before then pending, else if not between or before then terminated
                //    //    member.Status = moment().startOf('day').isBetween(moment(member.EffectiveDate, "YYYY-MM-DD").startOf('day'), moment(member.TermDate, "YYYY-MM-DD").endOf('day')) ? "Active"
                //    //        : moment().isBefore(moment(member.EffectiveDate).startOf('day')) ? "Pending" : "Terminated";
                //    //} else {
                //    //    //If current time is before Effective then pending, else if not before and no term date then active
                //    //    member.Status = moment().startOf('day').isBefore(moment(member.EffectiveDate, "YYYY-MM-DD").startOf('day')) ? "Pending" : "Active";
                //    //}
                //    member.Status = "Active"; //remove when status is added to API
                //    return member;
                //})
                logAPI("MBHWeb.Saga.HealthPlanServices.Members.GetMembersList.Get", start, null);
                yield put({ type: types.HP_GET_MEMBERS_LIST_SUCCESS, membersList: response, currentMemberId: memid, isFetching: false });
            }
        }
        catch (response) {
            console.error(response);
            // Microsoft Edge throws TypeMismatchError when fetch returns 401
            if (response.status === 401 || response.message === 'TypeMismatchError') {
                yield put({ type: types.VERIFY_LOGIN, errorCode: 401 });
                logAPI("MBHWeb.Saga.HealthPlanServices.Members.GetMembersList.Failure", start, null, '401 - login expired or invalid auth token');
            }
            else {
                yield put({ type: types.HP_GET_MEMBERS_LIST_FAILURE, error: response });
                logAPI("MBHWeb.Saga.HealthPlanServices.Members.GetMembersList.Failure", start, null, response);
            }
        }
    }
    else {
        console.log("webTPASaga: aalDown");
    }
}

export function* getUserProfile(params) {
    const start = new Date();
    const domainData = yield select((state) => state.domain);
    const stateData = yield select((state) => state.common);
    const memid = params.memberId || domainData.aai || domainData.hi || sessionData.healthPlanUserProfile.memberUserClaims.memberHccId;

    if (stateData && stateData.aalDown === false) {
        try {
            if (domainData && domainData.t) {
                const response = yield call(hpServicesApi.MemberApi.getMemberProfile, domainData.t, memid); //t = access token
                logAPI("MBHWeb.Saga.HealthPlanServices.Members.GetMembersProfile.Get", start, null);
                yield put({ type: types.HP_GET_PROFILE_SUCCESS, userProfile: response, isFetching: false });
            }
        }
        catch (response) {
            console.error(response);
            // Microsoft Edge throws TypeMismatchError when fetch returns 401
            if (response.status === 401 || response.message === 'TypeMismatchError') {
                yield put({ type: types.VERIFY_LOGIN, errorCode: 401 });
                logAPI("MBHWeb.Saga.HealthPlanServices.Members.GetMembersProfile.Failure", start, null, '401 - login expired or invalid auth token');
            }
            else {
                yield put({ type: types.HP_GET_PROFILE_FAILURE, error: response });
                logAPI("MBHWeb.Saga.HealthPlanServices.Members.GetMembersProfile.Failure", start, null, response);
            }
        }
    }
    else {
        console.log("webTPASaga: aalDown");
    }
}

export function* getSubscription() {
    const start = new Date();
    const domainData = yield select((state) => state.domain);
    const stateData = yield select((state) => state.common);
    const sessionData = yield select((state) => state.session);
    const memid = domainData.aai || domainData.hi ||sessionData.healthPlanUserProfile.memberUserClaims.memberHccId;
    if (stateData && stateData.aalDown === false) {
        try {
            if (domainData && domainData.t) {
                const response = yield call(hpServicesApi.MemberApi.getSubscription, domainData.t, memid); //t = access token, aai = American Airlines id
                logAPI("MBHWeb.Saga.HealthPlanServices.Members.GetSubscription.Get", start, null);
                yield put({ type: types.HP_GET_SUBSCRIPTION_SUCCESS, subscription: response, currentMemberId: memid, isFetching: false });
            }
        }
        catch (response) {
            console.error(response);
            // Microsoft Edge throws TypeMismatchError when fetch returns 401
            if (response.status === 401 || response.message === 'TypeMismatchError') {
                yield put({ type: types.VERIFY_LOGIN, errorCode: 401 });
                logAPI("MBHWeb.Saga.HealthPlanServices.Members.GetSubscription.Failure", start, null, '401 - login expired or invalid auth token');
            }
            else {
                yield put({ type: types.HP_GET_SUBSCRIPTION_FAILURE, error: response });
                logAPI("MBHWeb.Saga.HealthPlanServices.Members.GetSubscription.Failure", start, null, response);
            }
        }
    }
    else {
        console.log("webTPASaga: aalDown");
    }
}

export function* updateMemberAddress(params) {
    const start = new Date();
    const domainData = yield select((state) => state.domain);
    const stateData = yield select((state) => state.common);
    const sessionData = yield select((state) => state.session);
    const memid = domainData.aai || domainData.hi || sessionData.healthPlanUserProfile.memberUserClaims.memberHccId;

    if (stateData && stateData.aalDown === false) {
        try {
            if (domainData && domainData.t) {
                const response = yield call(hpServicesApi.MemberApi.updateMemberAddress, domainData.t, memid, params.email, params.address1, params.address2, params.city, params.state, params.zip, params.phone); //t = access token
                logAPI("MBHWeb.Saga.HealthPlanServices.Members.UpdateMemberAddress.Get", start, null);
                yield put({ type: types.HP_UPDATE_MEMBER_ADDRESS_SUCCESS, updateAddressResponse: response, isFetching: false });
            }
        }
        catch (response) {
            console.error(response);
            // Microsoft Edge throws TypeMismatchError when fetch returns 401
            if (response.status === 401 || response.message === 'TypeMismatchError') {
                yield put({ type: types.VERIFY_LOGIN, errorCode: 401 });
                logAPI("MBHWeb.Saga.HealthPlanServices.Members.UpdateMemberAddress.Failure", start, null, '401 - login expired or invalid auth token');
            }
            else {
                yield put({ type: types.HP_UPDATE_MEMBER_ADDRESS_FAILURE, error: response });
                logAPI("MBHWeb.Saga.HealthPlanServices.Members.UpdateMemberAddress.Failure", start, null, response);
            }
        }
    }
    else {
        console.log("webTPASaga: aalDown");
    }
}

export function* getCorrespondenceEmailAddress(params) {
    const start = new Date();
    const domainData = yield select((state) => state.domain);
    const stateData = yield select((state) => state.common);
    const sessionData = yield select((state) => state.session);
    const memid = domainData.aai || domainData.hi || sessionData.healthPlanUserProfile.memberUserClaims.memberHccId;

    if (stateData && stateData.aalDown === false) {
        try {
            if (domainData && domainData.t) {
                const response = yield call(hpServicesApi.MemberApi.getCorrespondenceEmailAddress, domainData.t, memid); //t = access token
                logAPI("MBHWeb.Saga.HealthPlanServices.Members.GetCorrespondenceEmailAddress.Get", start, null);
                yield put({ type: types.HP_GET_CORR_EMAIL_ADDRESS_SUCCESS, corrEmailAddress: response, isFetching: false });
            }
        }
        catch (response) {
            console.error(response);
            // Microsoft Edge throws TypeMismatchError when fetch returns 401
            if (response.status === 401 || response.message === 'TypeMismatchError') {
                yield put({ type: types.VERIFY_LOGIN, errorCode: 401 });
                logAPI("MBHWeb.Saga.HealthPlanServices.Members.GetCorrespondenceEmailAddress.Failure", start, null, '401 - login expired or invalid auth token');
            }
            else {
                yield put({ type: types.HP_GET_CORR_EMAIL_ADDRESS_FAILURE, error: response });
                logAPI("MBHWeb.Saga.HealthPlanServices.Members.GetCorrespondenceEmailAddress.Failure", start, null, response);
            }
        }
    }
    else {
        console.log("webTPASaga: aalDown");
    }
}